export default __webpack_public_path__ + "static/media/Group1497.ff0d68a5.png";